export const getErrorCode = (error: unknown) => {
    if (error && typeof error === 'object' && 'code' in error && typeof error['code'] === 'number') {
        return error.code;
    }
};

export const getErrorMessage = (error: unknown) => {
    if (error && typeof error === 'object' && 'message' in error && typeof error['message'] === 'string') {
        return error.message;
    }
};
